module.exports = __webpack_public_path__ + "static/media/24.5c73e589.JPG";